<template>
	<v-row>
		<v-col cols="12" class="my-0 py-0">
			<v-checkbox
				label="粗糙（砂砾、粉感、沙子）"
				value="rough"
				v-model="selectedTags"
				dense
				hide-details="auto"
			/>
		</v-col>
		<v-col cols="12" class="my-0 py-0 d-flex flex-row flex-wrap">
			<v-checkbox label="油滑的" :value="'greasy'" v-model="selectedTags" dense hide-details="auto" />
		</v-col>
		<v-col cols="12" class="my-0 py-0 d-flex flex-row flex-wrap">
			<v-checkbox
				label="滑顺（绒滑、丝滑、糖浆）"
				value="smooth"
				v-model="selectedTags"
				dense
				hide-details="auto"
			/>
		</v-col>
		<v-col cols="12" class="my-0 py-0 d-flex flex-row flex-wrap">
			<v-checkbox label="口腔干燥" value="dry" v-model="selectedTags" dense hide-details="auto" />
		</v-col>
		<v-col cols="12" class="my-0 py-0 d-flex flex-row flex-wrap">
			<v-checkbox label="金属味" value="metallic" v-model="selectedTags" dense hide-details="auto" />
		</v-col>
	</v-row>
</template>

<script>
export default {
	props: {
		tags: {
			type: Array,
			default: () => []
		}
	},
	emits: ['update:tags'],
	computed: {
		selectedTags: {
			get() {
				return this.tags || []
			},
			set(value) {
				this.$emit('update:tags', value)
			}
		}
	}
}
</script>
<style></style>
